<template>
  <footer class="footer" id="footer">
    <div class="footer__div_left">
      <router-link to="/mentionslegales" class="footer__div_left__router-link">
        Mentions-légales
      </router-link>
    </div>
    <!--  -->
    <div class="footer__div_middle">
      <a href="" class="footer__div_middle__a">CGV</a>
    </div>
    <!--  -->
    <div class="footer__div_right">
      <div class="footer__div_right__div_text">
        <p class="footer__div_right__div_text__p">&copy;</p>
      </div>
      <div class="footer__div_right__div_img">
        <img
          src="@/assets/Grand-Logo.png"
          alt="logo"
          class="footer__div_right__div_img__img"
        />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterDesktop",
};
</script>

<style lang="scss" scoped>
@import "@/style/color.scss";

#footer{
  display: grid;
}
.footer {
  background-color: white;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  height: 100px;
  overflow: hidden;

  border-top: 0.25rem solid $BG;

  &__div_left {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 0;
    grid-row-end: 1;
    margin-bottom: auto;
    margin-top: auto;

    &__router-link {
      margin-left: 0.5vw;
      color: inherit;
      font-size: 1.5rem;
    }

    //
    &__router-link:hover {
      color: $RV;
    }
  }

  //

  &__div_middle {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 0;
    grid-row-end: 1;
    margin-bottom: auto;
    margin-top: auto;
    text-align: center;

    &__a {
      color: inherit;
      font-size: 1.5rem;
    }

    //hover
    &__a:hover {
      color: $RV;
    }
  }

  &__div_right {
    grid-column-start: 3;
    grid-column-end: 4;
    grid-row-start: 0;
    grid-row-end: 1;
    display: flex;
    flex-direction: row;
    margin-bottom: auto;
    margin-top: auto;
    margin-left: 21vw;

    &__div_text {
      color: inherit;

      &__p {
        font-size: 5rem;
        font-weight: bold;
      }
    }

    &__div_img {
      margin-bottom: auto;
      margin-top: auto;

      &__img {
        margin-bottom: auto;
        margin-top: auto;
        height: 70px;
      }
    }
  }
}

@media screen and(max-width: 926px) {
  #footer {
    display: none;
  }
}
</style>
